import axios from 'axios';

export default class StaticApi {
  static async getVersion() {
    const response = await axios.get(`/version.json?t=${Date.now()}`);
    return response.data;
  }
}
